export default "__VITE_ASSET__co4WrUNE__"